import React, { Component } from 'react'

class CommonPersonalSettingHome extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }
  changed (name, e) {
    this.setState({[name]: e.target.value})
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'passwordChange':
        this.props.history.push('/' + this.userRoleUrl + '/password_change')
        break
      case 'emailChange':
        this.props.history.push('/' + this.userRoleUrl + '/email_change')
        break
      case 'notificationSettingChange':
        this.props.history.push('/' + this.userRoleUrl + '/notification_setting_change')
        break
      default:
        break
    }
  }
  renderPageNavi () {
    return (
      <section className='nav nav-page'>
        <div className='container'>
          <div className='row'>
            <div className='span7'>
              <header className='page-header'>
                <h3>個人設定<br />
                  <small>こちらから個人設定を開始できます。</small>
                </h3>
              </header>
            </div>
            <div className='page-nav-options'>
              <div className='span9' />
            </div>
          </div>
        </div>
      </section>
    )
  }
  render () {
    return (
      <div>
        {this.renderPageNavi()}
        <section className='page container'>
          <div className='box'>
            <div className='box-header'>
              <i className='icon-user' />
              <h5>個人設定</h5>
            </div>
            <div className='box-content'>
              <p>こちらでは、以下の個人向けの設定を変更できます。</p>
              <div className='visible-phone text-center'>
                <button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('passwordChange')}><i className='icon-lock' />パスワードの変更</button><br /><br />
                <button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('emailChange')}><i className='icon-envelope-alt' />メールアドレスの変更</button><br /><br />
                <button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('notificationSettingChange')}><i className='icon-info-sign' />通知受信可否設定の変更</button>
              </div>
              <table className='hidden-phone'>
                <tbody>
                  <tr>
                    <th><button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('passwordChange')}><i className='icon-lock' />パスワードの変更</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-cushion-menu-msg'>パスワードを変更できます。</div></td>
                  </tr>
                  <tr>
                    <th><button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('emailChange')}><i className='icon-envelope-alt' />メールアドレスの変更</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-cushion-menu-msg'>メールアドレスを変更できます。</div></td>
                  </tr>
                  <tr>
                    <th><button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('notificationSettingChange')}><i className='icon-info-sign' />通知受信可否設定の変更</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-cushion-menu-msg'>通知をメールで受信するかしないかの設定を変更できます。</div></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default CommonPersonalSettingHome



// WEBPACK FOOTER //
// ./src/common/pages/secure/PersonalSettingHome.js